var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-5 mt-5",
              attrs: { cols: "12", md: "9", lg: "7", xl: "5" },
            },
            [
              _c(
                "v-card",
                { attrs: { elevation: "5" } },
                [
                  _c(
                    "v-list-item",
                    { attrs: { "three-line": "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("div", { staticClass: "text-overline" }, [
                            _vm._v(
                              " " + _vm._s(_vm.clubData.Vereins_Name) + " "
                            ),
                          ]),
                          _c(
                            "v-list-item-title",
                            { staticClass: "text-h5 mb-1" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("registration.registrationForm")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("v-list-item-subtitle", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("registration.titleNote", {
                                    club: _vm.clubData.Vereins_Name,
                                  })
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-avatar",
                        { attrs: { tile: "", size: "150" } },
                        [
                          _c("v-img", {
                            attrs: {
                              src:
                                "data:image/png;base64, " + _vm.clubData.Logo,
                              contain: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form",
                              attrs: { id: "registration-form" },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onSubmit.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm.isGeneratingPdf
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-0 pb-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("h4", [
                                            _vm._v(_vm._s(_vm.headerText)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isGeneratingPdf
                                ? _c("v-row", [_c("v-divider")], 1)
                                : _vm._e(),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0 pb-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: _vm.$t(
                                            "registration.salutation"
                                          ),
                                          items: _vm.salutation,
                                          "item-value": "key",
                                          "item-text": "value",
                                          "auto-select-first": "",
                                          hide: "",
                                          name: "salutation",
                                        },
                                        model: {
                                          value: _vm.item.salutation,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.item,
                                              "salutation",
                                              $$v
                                            )
                                          },
                                          expression: "item.salutation",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0",
                                      attrs: { cols: "12", sm: "2" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        ref: "titleText",
                                        attrs: {
                                          label: _vm.$t("registration.title"),
                                          maxlength: 40,
                                          counter: "",
                                        },
                                        model: {
                                          value: _vm.item.title,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "title", $$v)
                                          },
                                          expression: "item.title",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0",
                                      attrs: { cols: "6", sm: "5" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        ref: "firstNameText",
                                        attrs: {
                                          label: _vm.$t(
                                            "registration.firstName"
                                          ),
                                          maxlength: 40,
                                          counter: "",
                                          rules: _vm.rules.required,
                                        },
                                        model: {
                                          value: _vm.item.firstName,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "firstName", $$v)
                                          },
                                          expression: "item.firstName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0",
                                      attrs: { cols: "6", sm: "5" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        ref: "lastNameText",
                                        attrs: {
                                          label: _vm.$t(
                                            "registration.lastName"
                                          ),
                                          maxlength: 40,
                                          counter: "",
                                          rules: _vm.rules.required,
                                        },
                                        model: {
                                          value: _vm.item.lastName,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "lastName", $$v)
                                          },
                                          expression: "item.lastName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pb-0" },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: _vm.$t("registration.gender"),
                                          items: _vm.gender,
                                          "item-value": "key",
                                          "item-text": "value",
                                          "auto-select-first": "",
                                          hide: "",
                                          name: "gender",
                                        },
                                        model: {
                                          value: _vm.item.gender,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "gender", $$v)
                                          },
                                          expression: "item.gender",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { staticClass: "pb-0" },
                                    [
                                      _c("date-time-picker", {
                                        attrs: {
                                          "text-field-clearable": "",
                                          "is-date-only": "",
                                          "text-field-label": _vm.$t(
                                            "registration.birthDate"
                                          ),
                                          "text-field-rules":
                                            _vm.rules.birthDate,
                                        },
                                        model: {
                                          value: _vm.item.birthDay,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "birthDay", $$v)
                                          },
                                          expression: "item.birthDay",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t("registration.street"),
                                          maxlength: 40,
                                          counter: "",
                                          rules: _vm.rules.required,
                                        },
                                        model: {
                                          value: _vm.item.street,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "street", $$v)
                                          },
                                          expression: "item.street",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0 pb-0",
                                      attrs: { cols: "3" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          name: "zip",
                                          label: _vm.$t("registration.zipCode"),
                                          rules: _vm.rules.required,
                                          maxlength: 5,
                                          counter: "",
                                        },
                                        on: {
                                          keypress: function ($event) {
                                            return _vm.isNumber($event)
                                          },
                                        },
                                        model: {
                                          value: _vm.item.postCode,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "postCode", $$v)
                                          },
                                          expression: "item.postCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0 pb-0",
                                      attrs: { cols: "7" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t("registration.city"),
                                          maxlength: 32,
                                          counter: "",
                                          rules: _vm.rules.required,
                                        },
                                        model: {
                                          value: _vm.item.city,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "city", $$v)
                                          },
                                          expression: "item.city",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0 pb-0",
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "registration.countryCode"
                                          ),
                                          rules: _vm.rules.required,
                                          maxlength: 3,
                                          counter: "",
                                        },
                                        model: {
                                          value: _vm.item.countryCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.item,
                                              "countryCode",
                                              $$v
                                            )
                                          },
                                          expression: "item.countryCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0 pb-0" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          name: "mobile-phone",
                                          label: _vm.$t("registration.mobile"),
                                          maxlength: 25,
                                          counter: "",
                                        },
                                        on: {
                                          keydown: [
                                            function ($event) {
                                              if (!$event.shiftKey) return null
                                              return _vm.forbiddenChar.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                            function ($event) {
                                              if (!$event.altKey) return null
                                              return _vm.forbiddenChar.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                            function ($event) {
                                              if (
                                                $event.ctrlKey ||
                                                $event.shiftKey ||
                                                $event.altKey ||
                                                $event.metaKey
                                              )
                                                return null
                                              return _vm.checkInputChar.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          ],
                                          paste: _vm.checkPastedValue,
                                        },
                                        model: {
                                          value: _vm.item.mobile,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "mobile", $$v)
                                          },
                                          expression: "item.mobile",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0 pb-0" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          name: "phone",
                                          label: _vm.$t("registration.phone"),
                                          maxlength: 25,
                                          counter: "",
                                        },
                                        on: {
                                          keydown: [
                                            function ($event) {
                                              if (!$event.shiftKey) return null
                                              return _vm.forbiddenChar.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                            function ($event) {
                                              if (!$event.altKey) return null
                                              return _vm.forbiddenChar.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                            function ($event) {
                                              if (
                                                $event.ctrlKey ||
                                                $event.shiftKey ||
                                                $event.altKey ||
                                                $event.metaKey
                                              )
                                                return null
                                              return _vm.checkInputChar.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          ],
                                          paste: _vm.checkPastedValue,
                                        },
                                        model: {
                                          value: _vm.item.telephone,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "telephone", $$v)
                                          },
                                          expression: "item.telephone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0 pb-0" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          name: "email",
                                          label: _vm.$t("registration.eMail"),
                                          rules: _vm.rules.required,
                                          maxlength: 60,
                                          counter: "",
                                        },
                                        model: {
                                          value: _vm.item.eMail,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "eMail", $$v)
                                          },
                                          expression: "item.eMail",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c("v-spacer"),
                                  _vm.file != null
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-0 pb-0 imageInput",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-img", {
                                            attrs: {
                                              "max-height": "100",
                                              "max-width": "100",
                                              src: _vm.previewUrl,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("v-spacer"),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0 pb-0 imageInput" },
                                    [
                                      _c("v-file-input", {
                                        attrs: {
                                          disabled: _vm.isLoading,
                                          label: _vm.$t(
                                            "registration.uploadPhoto"
                                          ),
                                          "show-size": "",
                                          "prepend-icon": "",
                                          "append-icon": "$file",
                                          "truncate-length": "50",
                                          rules: _vm.rules.profileImage,
                                          accept:
                                            "image/png, image/jpeg, image/bmp",
                                        },
                                        on: { change: _vm.previewImage },
                                        model: {
                                          value: _vm.file,
                                          callback: function ($$v) {
                                            _vm.file = $$v
                                          },
                                          expression: "file",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0 pb-0" },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value:
                                              "AA## XXXX XXXX XXXX XXXX XXXX XXXX XXXX XX",
                                            expression:
                                              "'AA## XXXX XXXX XXXX XXXX XXXX XXXX XXXX XX'",
                                          },
                                        ],
                                        attrs: {
                                          placeholder:
                                            "DE## #### #### #### #### ##",
                                          name: "iban",
                                          label: _vm.$t("registration.iban"),
                                          rules: _vm.rules.iban,
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.item.iban =
                                              _vm.item.iban.toUpperCase()
                                          },
                                        },
                                        model: {
                                          value: _vm.item.iban,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "iban", $$v)
                                          },
                                          expression: "item.iban",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pb-0" },
                                    [
                                      _c("v-checkbox", {
                                        staticStyle: {
                                          padding: "0",
                                          margin: "0",
                                        },
                                        attrs: {
                                          label: _vm.$t(
                                            "registration.accountOwner"
                                          ),
                                          rules: _vm.rules.minor,
                                        },
                                        model: {
                                          value: _vm.differentAccountOwner,
                                          callback: function ($$v) {
                                            _vm.differentAccountOwner = $$v
                                          },
                                          expression: "differentAccountOwner",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.differentAccountOwner
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-0 pb-0",
                                          attrs: { cols: "6", sm: "4" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t(
                                                "registration.firstName"
                                              ),
                                              rules: _vm.rules.required,
                                              maxlength: 40,
                                              counter: "",
                                            },
                                            model: {
                                              value: _vm.item.accOwnerFirstName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "accOwnerFirstName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.accOwnerFirstName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-0 pb-0",
                                          attrs: { cols: "6", sm: "4" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              maxlength: 40,
                                              counter: "",
                                              label: _vm.$t(
                                                "registration.lastName"
                                              ),
                                              rules: _vm.rules.required,
                                            },
                                            model: {
                                              value: _vm.item.accOwnerLastName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "accOwnerLastName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.accOwnerLastName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-0 pb-0",
                                          attrs: { cols: "6", sm: "4" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              name: "email",
                                              maxlength: 60,
                                              counter: "",
                                              label:
                                                _vm.$t("registration.eMail"),
                                              rules: _vm.rules.required,
                                            },
                                            model: {
                                              value: _vm.item.accOwnerEMail,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "accOwnerEMail",
                                                  $$v
                                                )
                                              },
                                              expression: "item.accOwnerEMail",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          rows: "2",
                                          dense: "",
                                          label: _vm.$t(
                                            "registration.clubInformation"
                                          ),
                                          placeholder: _vm.$t(
                                            "registration.clubInformationPlaceholder"
                                          ),
                                          rules: _vm.rules.required,
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.item.infoText,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.item, "infoText", $$v)
                                          },
                                          expression: "item.infoText",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.additionalFieldsInternal &&
                              _vm.additionalFieldsInternal.length > 0
                                ? _c(
                                    "v-row",
                                    { staticClass: "pt-2" },
                                    _vm._l(
                                      _vm.additionalFieldsInternal,
                                      function (field, index) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: index,
                                            staticClass: "pt-0 pb-0",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            field.Type.toLowerCase() === "text"
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    rules: field.Required
                                                      ? _vm.rules.required
                                                      : [],
                                                    label: field.Text,
                                                  },
                                                  model: {
                                                    value: field.Value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "Value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "field.Value",
                                                  },
                                                })
                                              : field.Type.toLowerCase() ===
                                                "checkbox"
                                              ? _c("v-checkbox", {
                                                  attrs: {
                                                    rules: field.Required
                                                      ? [
                                                          (val) =>
                                                            val ||
                                                            _vm.$t(
                                                              "error.requiredCheckboxGeneric"
                                                            ),
                                                        ]
                                                      : [],
                                                    label: field.Text,
                                                  },
                                                  model: {
                                                    value: field.Value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "Value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "field.Value",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0 pb-0" },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.$t(
                                            "registration.payDebitCharge"
                                          ),
                                          rules: [
                                            (val) =>
                                              val ||
                                              this.$t("error.requiredConsent"),
                                          ],
                                        },
                                        model: {
                                          value: _vm.item.payDebitCharge,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.item,
                                              "payDebitCharge",
                                              $$v
                                            )
                                          },
                                          expression: "item.payDebitCharge",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.privacyPolicyUrl.length > 0
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { staticClass: "pt-0 pb-0" },
                                        [
                                          _c(
                                            "v-checkbox",
                                            {
                                              attrs: {
                                                rules: [
                                                  (val) =>
                                                    val ||
                                                    this.$t(
                                                      "error.requiredPrivacyPolicy"
                                                    ),
                                                ],
                                              },
                                              model: {
                                                value: _vm.acceptPrivacyPolicy,
                                                callback: function ($$v) {
                                                  _vm.acceptPrivacyPolicy = $$v
                                                },
                                                expression:
                                                  "acceptPrivacyPolicy",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "label" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                  },
                                                  slot: "label",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$tc(
                                                          "registration.acceptPrivacyPolicy",
                                                          true
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "//" +
                                                          _vm.privacyPolicyUrl,
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "registration.privacyPolicy"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$tc(
                                                          "registration.acceptPrivacyPolicy",
                                                          false
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-row",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isMinor,
                                      expression: "isMinor",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pt-0 pb-0" },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.$t(
                                            "registration.minorPolicy"
                                          ),
                                          rules: _vm.rules.minor,
                                        },
                                        model: {
                                          value: _vm.acceptMinorPolicy,
                                          callback: function ($$v) {
                                            _vm.acceptMinorPolicy = $$v
                                          },
                                          expression: "acceptMinorPolicy",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "py-0 px-5" },
                                    [
                                      _c("VueHcaptcha", {
                                        ref: "recaptcha",
                                        attrs: {
                                          size: "invisible",
                                          sitekey:
                                            "02f5f991-6331-4f82-8967-66599a1bb15a",
                                        },
                                        on: {
                                          verify: _vm.onCaptchaVerify,
                                          expired: _vm.onCaptchaExpired,
                                          closed: _vm.onCaptchaClose,
                                          error: _vm.onCaptchaError,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.captchaClosed
                    ? _c("p", { staticClass: "red--text text-center" }, [
                        _vm._v(
                          _vm._s(_vm.$t("registration.hCaptchaClosedMessage"))
                        ),
                      ])
                    : _vm._e(),
                  _vm.captchaError
                    ? _c("p", { staticClass: "red--text text-center" }, [
                        _vm._v(
                          _vm._s(_vm.$t("registration.hCaptchaErrorMessage"))
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            text: "",
                            type: "submit",
                            form: "registration-form",
                            width: "100%",
                            loading: _vm.isLoading,
                            disabled: _vm.disableSubmit,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("registration.register")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-alert",
        {
          attrs: {
            type: _vm.alert.type,
            elevation: "10",
            dismissible: _vm.alert.dismissable,
            value: _vm.alert.isActive,
          },
        },
        [_vm._v(" " + _vm._s(_vm.alert.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }